"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lotteryAssistant = require("@/api/lotteryAssistant");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var winStatusMap = {
  0: '待开奖',
  1: '未中奖',
  2: '待领取',
  3: '已领取'
};
var _default = exports.default = {
  name: 'ActivityUsers',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    activityId: {
      type: [String, Number],
      default: ''
    },
    op: {
      type: String,
      default: 'edit'
    }
  },
  data: function data() {
    return {
      loading: false,
      winStatusMap: winStatusMap,
      total: 0,
      list: [],
      prizeOptions: [],
      multipleSelection: [],
      checkIds: [],
      statistics: {
        total: 0,
        prizeList: []
      },
      box: {
        show: false,
        prizeId: ''
      }
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '用户名称',
        prop: 'userName',
        defaultValue: '',
        type: 'input'
      }, {
        label: '抽奖码',
        prop: 'lotteryCode',
        defaultValue: '',
        type: 'input'
      }, {
        label: '钱包余额小等于',
        prop: 'minFreezeBalance',
        defaultValue: '',
        type: 'input',
        options: {
          type: 'number',
          step: 0.01
        }
      }, {
        label: '排除奖项',
        prop: 'excludePrizeIds',
        defaultValue: [],
        type: 'select',
        options: {
          list: this.prizeOptions,
          multiple: true
        }
      }];
    },
    columns: function columns() {
      var columns = [{
        key: 'userId',
        visible: true,
        label: "\u7528\u6237ID",
        width: 70
      }, {
        key: 'userInfo',
        visible: true,
        label: "\u7528\u6237",
        width: 120
      }, {
        key: 'freezeBalancePrice',
        visible: true,
        label: "\u94B1\u5305\u4F59\u989D",
        width: 120
      }, {
        key: 'prizeInfo',
        visible: true,
        label: "\u5956\u54C1",
        width: 120
      }];
      if (this.op === 'edit') {
        columns.push.apply(columns, [{
          key: 'lotteryCodeNum',
          visible: true,
          label: "\u62BD\u5956\u7801\u6570\u91CF",
          width: 100
        }, {
          key: 'winsFlag',
          visible: true,
          label: "\u662F\u5426\u4E2D\u5956",
          width: 80,
          formatter: 'text'
        }]);
      } else {
        columns.push.apply(columns, [{
          key: 'redeemCode',
          visible: true,
          label: "\u62BD\u5956\u7801\u6570\u91CF",
          width: 80
        }, {
          key: 'redPacketPrice',
          visible: true,
          label: "\u4E2D\u5956\u91D1\u989D",
          width: 80
        }, {
          key: 'winStatusDesc',
          visible: true,
          label: "\u5956\u54C1\u72B6\u6001",
          width: 80
        }]);
      }
      return columns;
    }
  },
  watch: {
    value: {
      handler: function handler(newV) {
        if (newV) {
          this.init();
        }
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    init: function init() {
      var _this = this;
      this.$nextTick(function () {
        _this.getPrizeOptions();
        _this.getRecordNum();
        _this.resetList();
      });
    },
    handleClose: function handleClose() {
      this.$emit('input', false);
      this.prizeOptions = [];
      this.statistics.total = 0;
      this.statistics.prizeList = [];
      this.list = [];
    },
    formatter: function formatter(key, value) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
      var defaultValue = type === 'text' ? '-' : '';
      var valueKey = type === 'text' ? 'label' : 'tag';
      if (key === 'winsFlag' && type === 'text') {
        return value ? '是' : '否';
      }
      if (key === 'winStatus' && type === 'text') {
        return winStatusMap[value];
      }
      return defaultValue;
    },
    getPrizeOptions: function getPrizeOptions() {
      var _this2 = this;
      (0, _lotteryAssistant.lotteryActivityPrizeListApi)(this.activityId).then(function (data) {
        _this2.prizeOptions = (data || []).map(function (item) {
          item.value = item.prizeId;
          item.label = item.awardName;
          return item;
        });
      });
    },
    getRecordNum: function getRecordNum() {
      var _this3 = this;
      (0, _lotteryAssistant.lotteryActivityRecordNumApi)(this.activityId).then(function (data) {
        _this3.statistics.total = data.totalParticipants;
        _this3.statistics.prizeList = data.prizeStatistics || [];
      });
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query, sortMap) {
      var params = _objectSpread(_objectSpread({}, query), {}, {
        activityId: this.activityId
      });
      return (0, _lotteryAssistant.lotteryActivityRecordListApi)(params).then(function (res) {
        var list = (res.list || []).map(function (item) {
          item.winsFlag = item.redeemCode ? 1 : 0;
          return item;
        });
        return {
          list: list,
          total: res.total
        };
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      this.checkedIds = this.multipleSelection.map(function (item) {
        return item.recordId;
      });
    },
    showPrizeModal: function showPrizeModal() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.box.prizeId = '';
      this.box.show = true;
    },
    closePrizeModal: function closePrizeModal() {
      this.box.show = false;
    },
    setPrize: function setPrize() {
      var _this4 = this;
      this.loading = true;
      var params = {
        recordIds: this.checkedIds,
        prizeId: this.box.prizeId
      };
      (0, _lotteryAssistant.lotteryActivityRecordUpdateApi)(params).then(function () {
        _this4.$message.success('设置成功');
        _this4.getRecordNum();
        _this4.refreshList();
        _this4.closePrizeModal();
      }).catch(function () {
        _this4.$message.error('设置失败');
      }).finally(function () {
        _this4.loading = false;
      });
    },
    cancelPrize: function cancelPrize(row) {
      var _this5 = this;
      this.loading = true;
      var params = {
        recordId: row.recordId
      };
      (0, _lotteryAssistant.lotteryActivityRecordCancelApi)(params).then(function () {
        _this5.$message.success('取消成功');
        _this5.getRecordNum();
        _this5.getList();
      }).catch(function () {
        _this5.$message.error('取消失败');
      }).finally(function () {
        _this5.loading = false;
      });
    }
  }
};